import React from "react";
import { FormControlLabel, Radio } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import { useTeamsContext } from "../../../../state/teams/context";
import TeamLogo from "../../../team/components/TeamLogo";
import updateFieldSelectorStyles from "../../styles/UpdateFieldSelector.styles";
import { useGameContextContext } from "../../../../state/game-context/context";

const TeamPossession = ({ teamPossession, setTeamPossession }) => {
	const classes = updateFieldSelectorStyles();

	const { state: teamState } = useTeamsContext();
	const homeTeam = teamState.homeTeam();
	const awayTeam = teamState.awayTeam();

	const { state: gameContextState } = useGameContextContext();
	const swapTeams = gameContextState.swapTeams();

	return (
		<Box
			display="flex"
			justifyContent="center"
			alignItems="center"
			flexDirection={swapTeams ? "row-reverse" : "row"}
			padding={1}
		>
			<FormControlLabel
				control={
					<Radio
						id="away-possession-radio-btn"
						className={swapTeams ? classes.radioRight : classes.radioLeft}
						checked={teamPossession === awayTeam.id}
						onChange={(e) => setTeamPossession(e.target.value)}
						value={awayTeam.id}
						name="teamPossession"
						inputProps={{ "aria-label": awayTeam.teamName }}
						color="primary"
					/>
				}
				labelPlacement={swapTeams ? "end" : "start"}
				label={<TeamLogo team={awayTeam} hideName />}
			/>
			<Typography className={classes.spacer}>:</Typography>
			<FormControlLabel
				control={
					<Radio
						id="home-possession-radio-btn"
						className={swapTeams ? classes.radioLeft : classes.radioRight}
						checked={teamPossession === homeTeam.id}
						onChange={(e) => setTeamPossession(e.target.value)}
						value={homeTeam.id}
						name="teamPossession"
						inputProps={{ "aria-label": homeTeam.teamName }}
						color="primary"
					/>
				}
				labelPlacement={swapTeams ? "start" : "end"}
				label={<TeamLogo team={homeTeam} hideName />}
			/>
		</Box>
	);
};

export default TeamPossession;
